<template>
    <div class="pt-16">
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Map2D :layers="mapLayers" is-first-menu-item-hidden />
    </div>
</template>

<script>
import Map2D from '@/components/Map/Map2D.vue';

export default {
    name: 'Map',
    components: {
        Map2D,
    },
    async asyncData({ $axios }) {
        // const categories = JSON.parse(JSON.stringify(mapCategoriesData.data));

        let mapLayers = [];

        await $axios.$get('/map/2d').then((res) => {
            mapLayers = res.data[0].layers;
        });

        return {
            mapLayers,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('map.index'),
            meta: this.$getPageMetaData('map.index'),
        };
    },
};
</script>

<style scoped></style>
